import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ArrowButton from '../../common/button-arrow';
import IncentivesList from './incentives-list';
import { getIncentives } from '../../../actions/incentives';
import PageTitle from '../../common/page-title';

import './styles.css';
import IncentivesSearch from './incentives-search';

class Incentives extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pageNumber: 1,
      name: '',
      dateFrom: '',
      dateTo: ''
    };
  }

  handleNameChange = (e) => {
    this.setState({ name: e.target.value });
  };

  handleDateFromChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ dateFrom: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ dateFrom: '' });
    }
  };

  handleDateToChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ dateTo: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ dateTo: '' });
    }
  };

  handleClear = () => {
    this.setState({
      pageNumber: 1,
      name: '',
      dateFrom: '',
      dateTo: ''
    }, this.handleSearch);
  };

  handleSearch = () => {
    const { dispatch } = this.props;
    const {
      name, dateFrom, dateTo
    } = this.state;

    dispatch(getIncentives(
      name,
      dateFrom,
      dateTo
    ));
  };

  handlePageChange = (page) => {
    this.setState({ pageNumber: page }, () => {
      this.props.dispatch(getIncentives(page));
    });
  };

  componentWillMount() {
    const { dispatch } = this.props;

    dispatch(getIncentives());
  }

  render() {
    const {
      fetched, fetching, incentives, pagination
    } = this.props;
    const {
      pageNumber, name, dateFrom, dateTo
    } = this.state;
    return (
      <div className="container-fluid incentives">
        <Row>
          <PageTitle>
            Incentives
          </PageTitle>
          <IncentivesSearch
            dateFromValue={dateFrom}
            dateToValue={dateTo}
            nameValue={name}
            onDateFromChange={this.handleDateFromChange}
            onDateToChange={this.handleDateToChange}
            onNameChange={this.handleNameChange}
            onSearch={this.handleSearch}
            onClear={this.handleClear}
          />
          <Col md={12}>
            <Row>
              <Link to="/admin/incentives/new">
                <ArrowButton
                  arrow={false}
                  className="add-incentive"
                  color="red"
                  permissions={{
                    action: 'create',
                    subjectClass: 'Incentive',
                  }}
                  submit={false}
                >
                  New Incentives
                </ArrowButton>
              </Link>
            </Row>
          </Col>
          <Row>
            <Col md={12}>
              <IncentivesList
                currentPage={pageNumber}
                fetched={fetched}
                fetching={fetching}
                incentives={incentives}
                onPageChange={this.handlePageChange}
                pagination={pagination}
              />
            </Col>
          </Row>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  incentives: state.incentives.incentives,
  fetching: state.incentives.fetching,
  fetched: state.incentives.fetched,
  pagination: state.incentives.paging,
});

export default connect(mapStateToProps)(Incentives);



// WEBPACK FOOTER //
// ./src/components/admin/incentives/index.jsx